"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyUserInfo = exports.destroyLocalStorageAuthUser = exports.minimizeUserInfoFields = exports.setLocalStorageAuthUser = exports.getLocalStorageAuthUser = exports.FIELDS_USER_INFO = void 0;
const constants_1 = require("../../constants");
const localStorageUtility_1 = __importDefault(require("../../hooks/localStorageUtility"));
const helpers_1 = require("../../helpers");
const auth_1 = __importDefault(require("../../auth"));
exports.FIELDS_USER_INFO = [
    "id",
    "full_name",
    "profile_picture",
    "phone_number",
    "hasPassword"
];
const getLocalStorageAuthUser = () => {
    var _a, _b;
    const cookies = (0, helpers_1.parseCookies)();
    // const {getItem} = localStorageUtility();
    const source = (_a = cookies[constants_1.CookiesConstants.SOURCE]) !== null && _a !== void 0 ? _a : (window.screen.width > 800 ? "desktop" : "mobile");
    const userInfo = (0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.USER_INFO]);
    const isLoggedOut = !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id);
    let fromCookieAuthObject = {
        userInfo,
        tgtTimestamp: (0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.AUTH], {}).t || cookies[constants_1.CookiesConstants.TGT_TIMESTAMP],
        tgtTicket: (0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.AUTH], {})
            .k || cookies[constants_1.CookiesConstants.TGT_TICKET],
        deviceUUID: cookies[constants_1.CookiesConstants.DEVICE_UUID] || (isLoggedOut ? cookies[constants_1.CookiesConstants.TRACKING_ID] : null),
        source,
    };
    if (cookies[constants_1.CookiesConstants.AUTH_V2]) {
        fromCookieAuthObject = Object.assign(Object.assign({}, fromCookieAuthObject), { tgtTimestamp: (0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.AUTH_V2], {}).t, tgtTicket: (0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.AUTH_V2], {}).k, deviceUUID: (_b = (0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.AUTH_V2], {})) === null || _b === void 0 ? void 0 : _b.device_uuid });
    }
    else {
        // set old cookies as auth v2
        (0, helpers_1.setCookie)(constants_1.CookiesConstants.AUTH_V2, JSON.stringify({
            device_uuid: fromCookieAuthObject.deviceUUID,
            t: fromCookieAuthObject.tgtTimestamp,
            k: fromCookieAuthObject.tgtTicket
        }));
    }
    return fromCookieAuthObject;
};
exports.getLocalStorageAuthUser = getLocalStorageAuthUser;
const setLocalStorageAuthUser = (data) => {
    const { setItem } = (0, localStorageUtility_1.default)();
    const defaultAuth = (0, exports.getLocalStorageAuthUser)();
    const authData = Object.assign(Object.assign({}, defaultAuth), data);
    (0, helpers_1.setCookie)(constants_1.CookiesConstants.USER_INFO, JSON.stringify(authData.userInfo));
    // setCookie(
    //     //@todo move to JSON helper to get/set data safely
    //     CookiesConstants.AUTH,
    //     JSON.stringify({t: authData.tgtTimestamp, k: authData.tgtTicket})
    // );
    (0, helpers_1.setCookie)(constants_1.CookiesConstants.AUTH_V2, JSON.stringify({
        deviceUUID: auth_1.default.getInstance().auth.deviceUUID,
        t: authData.tgtTimestamp,
        k: authData.tgtTicket
    }));
    (0, helpers_1.setCookie)(constants_1.CookiesConstants.AUTH, JSON.stringify({
        t: authData.tgtTimestamp,
        k: authData.tgtTicket
    }));
    if (authData.tgtTimestamp) {
        (0, helpers_1.destroyCookie)(constants_1.CookiesConstants.TGT_TIMESTAMP);
    }
    if (authData.tgtTicket) {
        (0, helpers_1.destroyCookie)(constants_1.CookiesConstants.TGT_TICKET);
    }
    if (authData.deviceUUID) {
        (0, helpers_1.destroyCookie)(constants_1.CookiesConstants.TRACKING_ID);
    }
    // setCookie(CookiesConstants.DEVICE_UUID, authData.deviceUUID);
    setItem(constants_1.LocalStorageConstants.AUTH_TOKEN, authData.authToken || "");
    setItem(constants_1.LocalStorageConstants.AUTH_TOKEN_EXPIRES, new Date(data.authTokenExpires).getTime());
    // setCookie(CookiesConstants.SESSION, JSON.stringify({
    //     id: authData.sessionId,
    //     startedAt: authData.sessionStartedAt
    // }))
};
exports.setLocalStorageAuthUser = setLocalStorageAuthUser;
const minimizeUserInfoFields = (userInfo) => {
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id))
        return null;
    const filtered_m = {};
    exports.FIELDS_USER_INFO.forEach((f) => {
        filtered_m[f] = userInfo[f];
    });
    return filtered_m;
};
exports.minimizeUserInfoFields = minimizeUserInfoFields;
const destroyLocalStorageAuthUser = () => {
    const { setItem } = (0, localStorageUtility_1.default)();
    setItem(constants_1.LocalStorageConstants.AUTH_TOKEN, "");
    constants_1.LogoutCookies.forEach((key) => {
        (0, helpers_1.destroyCookie)(key);
    });
    document.dispatchEvent(new CustomEvent("on-logout-success", {
        detail: {},
    }));
    //cookiesAndLocalStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
};
exports.destroyLocalStorageAuthUser = destroyLocalStorageAuthUser;
const emptyUserInfo = () => {
    (0, helpers_1.destroyCookie)(constants_1.CookiesConstants.USER_INFO);
};
exports.emptyUserInfo = emptyUserInfo;
